module.exports = __webpack_public_path__ + "static/media/undo.7c1eca1b.svg";